import { useNavigate } from 'react-router-dom';
import { buttonStyles, pageStyles } from '@/styles/sharedStyles';
import { hubOneOff, hubSubscription } from '@/assets';

export function Hub() {
  const navigate = useNavigate();
  
  return (
    <div className="max-w-5xl w-full mx-auto px-4">
      <div className="text-center mb-12">
        <h1 className={pageStyles.title}>Creative Gifting Made Simple<br />At Birdie Gifts</h1>
        <p className={pageStyles.subtitle}>
          Let Birdie Gifts manage your gifting calendar. The Birdies do the work. You Take the credit. 
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        {/* Subscription Card */}
        <div className="bg-white rounded-3xl shadow-lg overflow-hidden flex flex-col h-full">
          <div className="h-64 overflow-hidden">
            <img 
              src={hubSubscription}
              alt="Woman receiving gift"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="p-8 flex flex-col flex-1">
            <h3 className="text-2xl font-bold text-gray-800 mb-4">Start Your Subscription</h3>
            <p className="text-gray-600 mb-6 leading-relaxed flex-1">
              Simply add your important dates—birthdays, anniversaries, milestones—and Birdie takes care of the rest. From curated gift suggestions to beautifully wrapped deliveries, we handle the details so you can show up with thoughtfulness every time. Whether it's an annual celebration or a spontaneous, just-because surprise, Birdie keeps you ahead of the calendar and out of the last-minute scramble. 
            </p>
            {/* <p className="text-gray-600 mb-8">
              Tristique amet aliquet praesent leo facilisis. Quisque et id magna tellus integer.
            </p> */}
            <button 
              className={`${buttonStyles.primary} w-full mt-auto`}
              onClick={() => navigate('/subscription/1')}
            >
              Subscribe Now
            </button>
          </div>
        </div>

        {/* One-time Gift Card */}
        <div className="bg-white rounded-3xl shadow-lg overflow-hidden flex flex-col h-full">
          <div className="h-64 overflow-hidden">
            <img 
              src={hubOneOff}
              alt="Couple with gift"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="p-8 flex flex-col flex-1">
            <h3 className="text-2xl font-bold text-gray-800 mb-4">Send a One-Time Gift</h3>
            <p className="text-gray-600 mb-6 leading-relaxed flex-1">
              Need to send a thoughtful gift—but worried about striking out? The Birdies make it simple. Just choose your recipient, browse our curated gift list tailored to them, and we'll take care of the rest. From wrapping to delivery, your gift arrives on time and effortlessly.
            </p>
            {/* <p className="text-gray-600 mb-8">
              Tristique amet aliquet praesent leo facilisis. Quisque et id magna tellus integer.
            </p> */}
            <button 
              className={`${buttonStyles.primary} w-full mt-auto`}
              onClick={() => navigate('/one-off/1')}
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}